<template>
  <of-dialog
    :title="'请选择人员'+(multiple?'':'（单击选中）')"
    :appendToBody="true"
    @onCancel="close"
    @onConfirm="confirm"
    @onDialogResize="dialogResize"
    confirmName="确 定"
    width="850px"
  >
    <div slot="content" style="padding:10px">
      <el-row v-if="multiple" :gutter="5">
        <el-col :span="15">
          <div class="panel department-nav">
            <header>待选人员（单击选中）</header>
            <div
              class="el-transfer-panel__filter el-input el-input--small el-input--prefix"
              style="margin:10px;"
            >
              <input
                ref="keyword"
                v-model="keyword"
                @input="onSearch"
                @keyup.enter="onSearch"
                type="text"
                autocomplete="off"
                placeholder="请输入姓名（中文、拼音）或者员工号查询"
                class="el-input__inner"
              />
              <span class="el-input__prefix" @click="onSearch">
                <i
                  class="el-input__icon el-icon-search"
                  style="color:#1d5185;font-weight: bolder;font-size: 18px;"
                ></i>
              </span>
            </div>
            <div class="content" ref="leftArea">
              <div class="tree-nav">
                <p
                  v-show="selectedData.findIndex(x => x.Id === item.Id)===-1"
                  class="last-employee-item"
                  :title="item&&item?item.FullDepartmentName:''"
                  v-for="(item,index) in listData"
                  :key="index"
                  @click="selectData(item)"
                >
                  <span>{{item.RealName}}[{{item.EmployeeNo}}]</span>
                </p>
                <!-- <p v-if="!firstLoad" class="no-more">请输入关键字进行查询</p> -->
                <p  class="no-more" v-show="!listData.length">无数据</p>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="9">
          <div class="panel options-nav">
            <header>
              已选人员
              <span>{{selectedData.length}}</span>
            </header>
            <div class="content" ref="rightArea">
              <p
                class="last-employee-item"
                :title="item&&item?item.FullDepartmentName:''"
                v-for="(item,index) in selectedData"
                :key="index"
              >
                <i class="fa fa-remove" @click="removeData(item,index)" title="移除"></i>&nbsp;
                <span>{{item.RealName}}[{{item.EmployeeNo}}]</span>
              </p>
              <p class="no-more" v-show="!selectedData.length">无数据</p>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row v-else :span="24" style="margin-bottom:15px;overflow:auto">
        <div>
          <div
            class="el-transfer-panel__filter el-input el-input--small el-input--prefix"
            style="margin:0 0 10px 0;"
          >
            <input
              ref="keyword"
              v-model="keyword"
              @keyup.enter="onSearch"
              @input="onSearch"
              type="text"
              autocomplete="off"
              placeholder="请输入姓名（中文、拼音）或者员工号查询"
              class="el-input__inner"
            />
            <span class="el-input__prefix" @click="onSearch">
              <!-- <i class="el-input__icon el-icon-search" style="color:#1d5185;font-weight: bolder;font-size: 18px;"></i> -->
            </span>
          </div>
          <el-table
            size="small"
            style="padding-top:0; brder:1px solid red"
            :data="listData"
            :stripe="true"
            :height="285"
            :border="true"
            row-key="id"
            @row-click="clickRow"
          >
            <el-table-column
              prop="RealName"
              label="姓名"
              width="100"
              align="center"
              header-align="center"
            ></el-table-column>
            <!-- <el-table-column
              prop="EmployeeNo"
              label="员工号"
              width="100"
              align="center"
              header-align="center"
            ></el-table-column>-->
            <el-table-column
              prop="FullDepartmentName"
              label="部门"
              :show-overflow-tooltip="true"
              header-align="center"
            ></el-table-column>
          </el-table>
        </div>
      </el-row>
      <!-- <el-row :gutter="5">
        最近使用：
        <span v-for="(item,index) in lastUseEmployee" :key="index">
          <el-button
            class="last-select-item"
            round
            @click="selectData(item)"
            type="text"
            size="mini"
          >{{item.RealName|filterRealName(item)}}</el-button>
        </span>
      </el-row> -->
    </div>
    <div slot="footer-operation" v-if="!multiple"></div>
  </of-dialog>
</template>

<script>
import OfDialog from "@/components/controls/of_dialog/of_dialog";
import { queryEmployeePickerData } from "@/modules/sys/api/employee.js";

export default {
  name: "sys-employee-picker",
  props: {
    multiple: {
      type: Boolean,
      default: false
    },
    defaultSelect: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      listData: [],
      loading: false,
      selectedData: [],
      lastUseEmployee: [],
      currentPage: 1,
      pageSize: 30,
      sortOrder: "asc",
      searchFields: "EmployeeNo,RealName,Spell,Account",
      keyword: "",
      searchTimer: null,
      firstLoad: false
    };
  },
  components: {
    OfDialog
  },
  mounted() {
    setTimeout(() => {
      this.$refs.keyword.focus();
    }, 100);

    this.defaultSelect.forEach(x => {
      this.selectedData.push(x);
    });
    let lastEmployee = localStorage.getItem("LAST_USE_EMPLOYEE");
    if (lastEmployee) {
      this.lastUseEmployee = JSON.parse(lastEmployee);
    }
    this.getData()
  },
  filters: {
    filterRealName(realName, item) {
      if (realName.length > 5) {
        realName = realName.substr(0, 5) + "...";
      }
      return `${realName}[${item.EmployeeNo}]`;
    }
  },
  methods: {
    getData() {
      let vm = this
      // this.listData = [];
      this.loading = true;
      // this.firstLoad = true;
      queryEmployeePickerData(
        this.currentPage,
        this.pageSize,
        this.sortOrder,
        this.searchFields,
        this.keyword,
        ""
      )
        .then(rep => {
          if (rep.data.Code === 0) {
            //this.total = rep.data.Data.total
            this.listData = rep.data.Data.rows;
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    onChange() {
      this.listData = [];
      if (this.loading || !this.keyword || this.keyword.length < 2) return;
      this.searchTimer && clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        this.onSearch();
      }, 500);
    },
    onSearch() {
      debugger
      // this.listData = [];
      // if (!this.keyword) return;
      this.loading = true;
      // this.firstLoad = true;
      queryEmployeePickerData(
        this.currentPage,
        this.pageSize,
        this.sortOrder,
        this.searchFields,
        this.keyword,
        ""
      )
        .then(rep => {
          if (rep.data.Code === 0) {
            //this.total = rep.data.Data.total
            this.listData = rep.data.Data.rows;
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    selectData(data) {
      if (this.multiple) {
        let index = this.selectedData.findIndex(x => x.Id === data.Id);
        if (index === -1) {
          this.selectedData.push(data);
        }
      } else {
        this.selectedData = [];
        this.selectedData.push(data);
        this.confirm();
      }
    },
    removeData(item, index) {
      this.selectedData.splice(index, 1);
    },
    close() {
      this.$emit("pickerCallBack", null);
    },
    clickRow(item) {
      this.selectedData = [];
      this.selectedData.push(item);
      this.confirm();
    },
    confirm() {
      if (this.selectedData.length === 0) {
        this.$message({
          message: "请选择人员",
          type: "warning"
        });
      } else {
        this.$emit(
          "pickerCallBack",
          this.multiple ? this.selectedData : this.selectedData[0]
        );
        this.setLastStorage(this.selectedData);
      }
    },
    setLastStorage(arr) {
      var lastCount = 20;
      arr.forEach(data => {
        let i = this.lastUseEmployee.findIndex(x => x.Id === data.Id);
        if (i > -1) {
          this.lastUseEmployee.splice(i, 1);
        }
        this.lastUseEmployee.unshift(data);
      });
      this.lastUseEmployee.splice(
        lastCount,
        this.lastUseEmployee.length - lastCount
      );
      localStorage.setItem(
        "LAST_USE_EMPLOYEE",
        JSON.stringify(this.lastUseEmployee)
      );
    },
    dialogResize(height) {
      let leftArea = this.$refs.leftArea;
      let rightArea = this.$refs.rightArea;
      //  let lastUseArea = this.$refs.lastUseArea;

      height -= 110;
      if (leftArea) {
        leftArea.style.maxHeight = `${height - 54}px`;
        leftArea.style.minHeight = `${height - 54}px`;
      }
      if (rightArea) {
        rightArea.style.maxHeight = `${height}px`;
        rightArea.style.minHeight = `${height}px`;
      }
      // if (lastUseArea) {
      //   lastUseArea.style.maxHeight = `${height}px`;
      //   lastUseArea.style.minHeight = `${height}px`;
      // }
    }
  }
};
</script>
<style scoped>
.panel {
  border: 1px solid #ebeef5;
  overflow: hidden;
  width: 100%;
  border-radius: 3px;
}
.department-nav {
  min-width: 300px;
}
.options-nav {
  min-width: 200px;
}
.panel > header {
  background: #f5f7fa;
  padding: 5px 10px 5px 10px;
  border-bottom: 1px solid #ebeef5;
  position: relative;
}
.panel > header > span {
  position: absolute;
  right: 15px;
  color: #909399;
  font-size: 12px;
  font-weight: 400;
}
.panel > .content {
  padding: 10px;
  overflow: auto;
}
.no-more {
  padding: 5px;
  color: #909399;
  text-align: center;
}
.tree-nav >>> .iconClass {
  color: #555;
  font-size: 15px;
}
.last-employee-item {
  font-size: 14px;
  cursor: pointer;
  margin-bottom: 5px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-left: 10px;
  padding-right: 10px;
}
.last-employee-item > span:hover {
  color: #004a86;
}
.last-employee-item .fa-remove:hover {
  color: #ff0000;
}
.last-select-item {
  margin-bottom: 5px;
  margin-left: 5px;
  padding: 3px 10px;
  overflow: auto;
}
</style>
